import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Tooltip from 'components/common/Tooltip';
import IconArticle from 'components/icons/IconArticle';
import IconCrossBold from 'components/icons/IconCrossBold';


const styles = theme => ({
  iconRejected: {
    position: 'relative',
  },
  iconArticle: {
    display: 'block',
    width: 22,
    height: 22,
    color: theme.palette.grey[600],
  },
  iconCrossBold: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: 12,
    height: 12,
    color: theme.palette.validation[500],
  },
  tooltipRejected: {
    margin: '0 0 -4px 4px',
  },
});

const ProductClaimIsRejectedField = ({ input, classes }) => {
  if (input.value) {
    return (
      <Tooltip
        className={classes.tooltipRejected}
        content={
          <Typography>
            Rejected
          </Typography>
        }
        placement="top"
      >
        <div className={classes.iconRejected}>
          <IconArticle className={classes.iconArticle} />
          <IconCrossBold className={classes.iconCrossBold} />
        </div>
      </Tooltip>
    );
  }
  return '';
};

ProductClaimIsRejectedField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ]),
  }).isRequired,
  classes: PropTypes.shape({
    iconRejected: PropTypes.string.isRequired,
    iconArticle: PropTypes.string.isRequired,
    iconCrossBold: PropTypes.string.isRequired,
    tooltipRejected: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ProductClaimIsRejectedField);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimIsRejectedField.js